// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\EquipmentSection\\\\components\\\\EquipmentAccordion.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\EquipmentSection\\components\\EquipmentAccordion.tsx");
  import.meta.hot.lastModified = "1757171103296.608";
}
// REMIX HMR END

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";
import { Button } from "~/components/ui/button";
export function EquipmentAccordion({
  equipment
}) {
  return <Accordion type="single" collapsible className="w-full" defaultValue="1">
      {equipment.map(item => {
      return <AccordionItem key={item.id} value={item.id} className="border-b border-white/10">
            <AccordionTrigger className="hover:no-underline py-6 group [&[data-state=open]>svg]:rotate-180">
              <h3 className="text-body-2 lg:text-heading-5 tracking-[-0.01em] text-white uppercase text-left pr-4">
                {item.title}
              </h3>
            </AccordionTrigger>

            <AccordionContent className="pb-6 flex flex-col gap-4">
              <p className="text-body-3 text-white/80">
                {item.content}
              </p>
              {/* CTA Button */}
              <div className="flex">
                <Button variant="outline-white" size="lg" className="bg-transparent border-white/30 text-white hover:bg-white/10 hover:border-white/50 uppercase tracking-wider font-medium" arrowRight>
                  BOOK A STUDIO
                </Button>
              </div>
            </AccordionContent>
          </AccordionItem>;
    })}
    </Accordion>;
}
_c = EquipmentAccordion;
var _c;
$RefreshReg$(_c, "EquipmentAccordion");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;